import { render, staticRenderFns } from "./LikewizeRepairHome.vue?vue&type=template&id=2105b0ee&"
import script from "./LikewizeRepairHome.vue?vue&type=script&lang=js&"
export * from "./LikewizeRepairHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports